import BaseStore from './baseStore'
import { generateMultipleItemOverview } from '@/store/baseOverview'
import { blend } from '@/utils/colorBlending'

export const namespaced = true

const baseUrl = '/soil_layers/'
import api from '../api/api'

const baseStore = new BaseStore(baseUrl)
const baseOverview = generateMultipleItemOverview({
  itemFilter: (soilLayer, stabSchematisationStage) =>
    soilLayer.properties.soil_composition === stabSchematisationStage.soilcomposition,
  duplicationCheckFunc: (soilLayer, soilCompositionId) =>
    soilLayer.properties.soil_composition === soilCompositionId,
  responseDataGetter: (response) => response.data.features
})

const getDefaultState = () => {
  return {
    ...structuredClone(baseStore.state)
  }
}

export const state = {
  tintColor: '#0094ff',
  ...structuredClone(baseOverview.state),
  ...getDefaultState()
}

export const mutations = {
  ...baseStore.mutations,
  ...baseOverview.mutations,
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  }
}

export const actions = {
  ...baseStore.actions,
  ...baseOverview.actions,
  resetState({ commit }) {
    commit('RESET_STATE')
  },
  async fetchItems(context, id) {
    let url = context.state.baseUrl + `?search=${id}`
    let response = await api.get(url)
    if (response.data['features']) context.commit('SET_ITEMS', response.data['features'])
  },
  async generate(context, soilCompositionId) {
    const url = `${baseUrl}${soilCompositionId}/generate/`
    try {
      const response = await api.post(url, {
        properties: { soil_composition: soilCompositionId }
      })
      if (response.data['features']) {
        context.commit('SET_ITEMS', response.data['features'])
      }
      const topoProfileId = context.rootGetters['stabSchematisationStage/currentTopoProfileId']
      await context.dispatch('topoProfilePoint/fetchItems', topoProfileId, {
        root: true
      })
    } catch (error) {
      context.commit('RESET_STATE')
    }
  }
}
export const getters = {
  ...baseOverview.getters,
  getPlotData:
    (state, getters) =>
    (stabSchematisationStage = null) => {
      const items = getters.getItemsByStabSchematisationStage(stabSchematisationStage)
      return items.map((item) => getters.getSingleSoilLayer(item))
    },
  getSingleSoilLayer: (state, getters, rootState, rootGetters) => (soilLayer) => {
    const id = soilLayer.id
    let name = rootGetters['baseSoilType/getBaseSoilTypeById'](
      soilLayer.properties.base_soil_type
    )?.name
    const originalColor = rootGetters['baseSoilType/getBaseSoilTypeById'](
      soilLayer.properties.base_soil_type
    )?.color
    let filledColor = originalColor
    if (soilLayer.properties.drained) {
      name += ' (drained)'
    } else if (soilLayer.properties.drained !== null) {
      name += ' (undrained)'
      filledColor = blend(originalColor, state.tintColor, 0.1)
    }
    const coordinates = soilLayer['geometry']['coordinates'][0]
    const styleLine = {
      color: 'black',
      width: 1
    }
    let scatter = {
      x: [],
      y: [],
      line: { simplify: false },
      fill: 'toself',
      fillcolor: filledColor,
      mode: 'lines+text+markers',
      hovertemplate: '(%{x}, %{y})<extra></extra>',
      type: 'scatter',
      name: null,
      textangle: null,
      textfont: {
        family: 'Roboto'
      }
    }
    if (coordinates) {
      scatter.x = coordinates.map((item) => item[0])
      scatter.y = coordinates.map((item) => item[1])
    } else {
      scatter.x = []
      scatter.y = []
    }
    scatter.id = id
    scatter.name = name
    scatter.line = styleLine
    scatter.marker = {
      color: 'black',
      size: 2
    }
    return scatter
  }
}
